query TagsList(
  $page: Int
  $rowsPerPage: Int
  $filter: TagsFilterInput
) {
  tags(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      title
      path
      url
      type {
        id
        title
      }
      createdAt
      updatedAt
    }
  }
}
